export const Filterable = {

    async filter(params, callback=() => {}) {
        let result;

        await $.ajax({
            url: `${this.urlRoot}/filter`,
            method: "GET",
            data: params,
            success: (response) => { callback(response); result = response }
        });

        return result;
    },
}
